"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitorBase = void 0;
class VisitorBase {
    visit(ast) {
        if (ast.root)
            ast.root.accept(this);
    }
    visitParenthesisExpr(node) {
        return;
    }
    visitPlusMinusExpr(node) {
        return;
    }
    visitPowExpr(node) {
        return;
    }
    visitSignedExpr(node) {
        return;
    }
    visitTimesDivExpr(node) {
        return;
    }
    visitBooleanExpr(node) {
        return;
    }
    visitColumn(node) {
        return;
    }
    visitForeign(node) {
        return;
    }
    visitComparisonExpr(node) {
        return;
    }
    visitConcrete(node) {
        return;
    }
    visitConstant(node) {
        return;
    }
    visitFormula(node) {
        return;
    }
    visitSymbol(node) {
        return;
    }
    visitSimpleFormula(node) {
        return;
    }
    visitArray(node) {
        return;
    }
}
exports.VisitorBase = VisitorBase;
